export default "__VITE_ASSET__BxGE_g6t__"